import * as React from "react";
import { SWRConfig } from "swr";
import { useNavigate } from "react-router";

import { fetcher } from "./../../../services/fetcher";
// import useRefreshToken from "./../../../hooks/UseRefreshToken/index";

const SWRconfig = ({ children }) => {
  const navigate = useNavigate();
  // const [fetchRefreshData] = useRefreshToken();

  const handleError = (e) => {
    if (e.request.status === 401) {
      // fetchRefreshData();
    }
    if (e.request.status === 502) {
      // if path not underconstruction
      navigate("/underconstruction", { replace: true });
    }
  };

  return (
    <SWRConfig
      value={{
        // refreshInterval: 15000,
        revalidateOnFocus: false,
        errorRetryInterval: 800,
        errorRetryCount: 10,
        revalidateOnReconnect: true,
        onError: (e) => handleError(e),

        fetcher,
      }}
    >
      {children}
    </SWRConfig>
  );
};
export default SWRconfig;
